module.exports = {
  fetch: `query getAttempts($caseId: String, $userId: String) {
    attempts(filter: { 
      caseId: { eq: $caseId },
      userId: { eq: $userId }
    }) {
      id
      caseId
      userId
      assignmentId
    }
  }`,
  fetchByAssignmentId: `
    query getAttemptsByAssignmentId($assignmentId: String) {
      attempts(filter: { 
        assignmentId: { eq: $assignmentId }
      }) {
        id
        caseId
        userId
        assignmentId
      }
    }
  `
};
